import ModalFilterService from '@/services/modal-filter.service'

export default {
  namespaced: true,
  state: {
    tipo: null,
    filters: [],
    filters2: [],
    rows: [],
    rowsObj: [
      { key: 'recomendar', show: true },
      { key: 'atuacao', show: true },
      { key: 'modalidade', show: true },
      { key: 'acomodacao', show: true },
      { key: 'coparticipacao', show: true },
      { key: 'reembolso', show: true },
      { key: 'taxas-iof', show: true },
      { key: 'informacoes', show: true },
      { key: 'hospitais', show: true },
      { key: 'valores', show: true },
      { key: 'resumo', show: true },
      { key: 'mei', show: true }
    ],
    loading: false,
    error: null
  },
  mutations: {
    setLoading: (state, loading) => state.loading = loading,
    setError: (state, error) => state.error = error,
    setTipo: (state, tipo) => state.tipo = tipo,
    setFilters: (state, filters) => state.filters = filters,
    setFilters2: (state, filters2) => state.filters2 = filters2,
    setRows: (state, rows) => state.rows = rows,
  },
  actions: {
    tipo({commit}, tipo) {
      commit('setTipo', tipo)
    },
    async ['load']({ commit }, tree) {
      try {
        commit('setLoading', true)
        const data = await ModalFilterService.loadDefaultTree(tree)
        commit('setFilters', data)
      } catch (error) {
        commit('setError', errr)
      } finally {
        commit('setLoading', false)
      }
    },
    async ['load2']({ commit }, tree) {
      try {
        commit('setLoading', true)
        const data = await ModalFilterService.loadDefaultTree2(tree)
        commit('setFilters2', data)
      } catch (error) {
        commit('setError', errr)
      } finally {
        commit('setLoading', false)
      }
    },
    update({commit}, filters) {
      commit('setFilters', filters ? filters : [])
    },
    updateRows({commit}, rows) {
      commit('setRows', rows ? rows : [])
    }
  },
  getters: {
    getLoading: state => state.loading,
    getError: state => state.error,
    getTipo: state => state.tipo,
    getFilters: state => state.filters,
    getFilters2: state => state.filters2,
    getRowsObj: state => state.rowsObj,
    getRows: state => state.rows.length ? state.rows : state.rowsObj
  }
}
